// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar-module--sidebar--2OrhV","logo":"Sidebar-module--logo--2CVgv","active":"Sidebar-module--active--1dRAY"};